<template>
<div class="chapter">
<div class="inner_page">
<p style="height:100%;margin-top:0;"><a id="tp"><img alt="001" class="imgepub" src="bano_9781601638632_oeb_001_r1.jpg" style="height:100%;text-align:center;"/></a></p><a id="tp">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bano_9781601638632_oeb_tp_r1.vue?664642fa